module.exports = __webpack_public_path__ + "static/media/SearchImage.3a011257.png";